export const roles = {
  owner_admin: "المالك / المدير",
  office_planner: "المكتب / المخطّط",
  operator: "مشغّل الورشة",
};
